import { useEffect, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Brand } from '../components/Brand';
import { Icon } from '../components/Icon';
import { setLanguage } from '../i18n';
import { useTheme } from '../theme';

/** Geteilte Anmeldemaske: links Marke mit wechselnden Sprüchen, rechts Formular (Prototyp-Design). */
export function AuthLayout({ children }: { children: ReactNode }) {
  const { t, i18n } = useTranslation();
  const slogans = t('login.slogans', { returnObjects: true }) as string[];
  const [n, setN] = useState(0);
  const [fade, setFade] = useState(false);
  const theme = useTheme();
  useEffect(() => {
    const reduce = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    let h: ReturnType<typeof setTimeout> | undefined;
    const iv = setInterval(() => {
      setFade(true);
      h = setTimeout(() => {
        setN((x) => x + 1);
        setFade(false);
      }, 400);
    }, 4000);
    return () => {
      clearInterval(iv);
      if (h) clearTimeout(h);
    };
  }, []);
  return (
    <div className="auth">
      <div className="auth-hero">
        <Brand dark slogan="Your Screens. Your Content." />
        <div>
          <div className="eyebrow">{t('login.eyebrow')}</div>
          <h1 aria-live="off" style={{ opacity: fade ? 0 : 1 }}>{slogans[n % slogans.length]}</h1>
          <p>{t('login.lead')}</p>
          <div className="mock" aria-hidden>
            <div className="m1">HERBST-SPECIAL</div><div className="m2">18:30</div>
            <div className="m3">+++ Neuer Spinning-Kurs ab Montag +++ Jetzt Probetraining buchen +++</div>
          </div>
        </div>
        <div className="powered"><Icon name="screen" /> POWERED BY NETQ10</div>
      </div>
      <div className="auth-form">
        <div className="auth-tools">
          <div className="seg" role="group" aria-label={t('shell.language')}>
            {(['de', 'en'] as const).map((l) => (
              <button key={l} className={i18n.language === l ? 'on' : ''} aria-pressed={i18n.language === l} onClick={() => setLanguage(l)}>{l.toUpperCase()}</button>
            ))}
          </div>
          <button className="btn ghost icon" aria-label={t('shell.theme')} onClick={theme.toggle}><Icon name={theme.resolved === 'dark' ? 'sun' : 'moon'} /></button>
        </div>
        <div className="auth-card">{children}</div>
      </div>
    </div>
  );
}
